import { Box, Typography, ToggleButtonGroup, ToggleButton } from "@mui/material";
import { useLocation } from "react-router-dom";

export const ToggleCategory: React.FC<{selected: string, setSelected(value: string): void}> = ({ selected, setSelected }) => {
  
  const location = useLocation();

  const isWhite = location.pathname === "/";

  const handleToggle = (event: React.MouseEvent<HTMLElement>, newValue: string) => {
    if (newValue !== null) {
      setSelected(newValue);
    }
  };
  
  return (
    <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
      <Typography
        variant="h6"
        textAlign="center"
        color={isWhite? "#fff" : 'warning'}
        sx={{
          fontWeight: 700,
        }}
      >
        FIQUE POR DENTRO DAS <span style={{ color: "primary.warning" }}>NOVIDADES</span>
      </Typography>

      <ToggleButtonGroup
        value={selected}
        exclusive
        onChange={handleToggle}
        sx={{
          borderRadius: "8px",
          overflow: "hidden",
          borderColor: "#fff",
        }}
      >
        <ToggleButton
          value="Notícia"
          sx={{
            backgroundColor: selected === "Notícia" ? "transparent" : "white", // Fundo transparente se selecionado
            color: selected === "Notícia" ? "white" : "#000", // Texto branco se selecionado
            borderColor: selected === "Notícia" ? "white" : "transparent", // Borda branca se selecionado
            fontWeight: 600,
            "&:hover": {
              backgroundColor: "rgba(255, 255, 255, 0.1)", // Fundo leve no hover
            },
          }}
        >
          Notícia
        </ToggleButton>
        <ToggleButton
          value="Blog"
          sx={{
            backgroundColor: selected === "Blog" ? "transparent" : "white", // Fundo transparente se selecionado
            color: selected === "Blog" ? "white" : "#000", // Texto branco se selecionado
            borderColor: selected === "Blog" ? "white" : "transparent", // Borda branca se selecionado
            fontWeight: 600,
            "&:hover": {
              backgroundColor: "rgba(255, 255, 255, 0.1)", // Fundo leve no hover
            },
          }}
        >
          Blog
        </ToggleButton>
      </ToggleButtonGroup>


    </Box>
  );
  };
  